<template>
  <v-card>
    <v-card-title class="headline font-weight-thin">Delete Confirmation</v-card-title>
    <v-card-text v-if="imageIsInUse">
      {{ imageIsInUseHelpText }}
    </v-card-text>
    <v-card-text v-else>
      Are you sure you want to delete file
      <span class="font-weight-bold">{{ record.originalFilename }}</span
      >?
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn @click="cancel" class="mr-2" data-cy="cancelDelete" outlined>Cancel</v-btn>
      <v-btn
        :disabled="imageIsInUse"
        @click="submit"
        class="elevation-0 font-weight-bold"
        color="red"
        data-cy="confirmDelete"
        outlined
        >Delete</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    imageIsInUse() {
      const imageIsInUse = this.richTextFieldList.some(field =>
        this.releaseNote[field]?.includes(this.record.filename)
      );
      return imageIsInUse;
    },
    imageIsInUseHelpText() {
      if (this.imageIsInUse) {
        return "This image is in use in the release note. Remove it before deleting.";
      } else {
        return;
      }
    },
    ...mapState({
      releaseNote: state => state.releaseNote.releaseNoteRecord,
      richTextFieldList: state => state.releaseNote.richTextFieldList,
    }),
  },
  methods: {
    cancel() {
      this.$emit("setDialog", false);
    },
    async submit() {
      const { originalFilename } = this.record;

      try {
        await this.remove(this.record);
        this.$emit("setDialog", false);
        this.$notifySuccess({ message: `Successfully deleted ${originalFilename}` });
      } catch (e) {
        this.$notifyError({
          message: `Could not delete file.`,
        });
      }
    },
    ...mapActions({
      remove: "file/remove",
    }),
  },
  props: { record: { required: true, type: Object } },
};
</script>
